<template>
  <!-- https://www.codeply.com/go/9jCB86eXFl -->
  <nav class="navbackground navbar navbar-expand-lg navbar-dark bg-dark pl-2 pr-2" v-bind:class="{ 'navbarOpen': show }">
    <a class="navbar-brand ml-5" href="/#/">
      <img width="30px" class="mr-3 rounded shadow-sm" src="../assets/logo.png" />
      <b>EXPERT EVIDENCE</b>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      @click.stop="toggleNavbar()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent" v-bind:class="{ 'show': show }">
      <ul class="navbar-nav ml-auto pl-5" dir="rtl">
        <li class="nav-item active">
          <a class="nav-link" href="/#/">HOME <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/#/verify">VERIFY</a>
        </li>
      </ul>
    </div>
  </nav>
  <!--     <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="/#/">
          <img width="30px" class="mr-3 rounded shadow-sm" src="../assets/logo.png" />
          <b>EXPERT EVIDENCE</b>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div class="navbar-nav ml-auto">
            <a class="nav-item nav-link active" href="/#/">HOME <span class="sr-only">(current)</span>
            </a>
            <a class="nav-item nav-link" href="/#/getstarted?mode=2">
              DOC SIGN
            </a>
            <a class="nav-item nav-link" href="/#/getstarted?mode=1">
              WEB CAPTURE
            </a>
            <a class="nav-item nav-link" href="/#/verify"> VERIFY </a>
          </div>
        </div>
      </nav>
    </div> -->
</template>
<script>
export default {
  name: "Header",
  props: {
    viewType: String,
  },
  data() {
    return {
      show: true
    }
  },
  mounted() {
  },
  methods: {
    toggleNavbar() {
      this.show = !this.show
    }
  }
}
</script>
<style scoped>
.navbackground{
  background-color:  #000 !important;
}

.navbar-brand,
.nav-link {
  color: #cccccc !important;
}

.nav-link {
  font-weight: 400 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue